module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAYAAACK7SRjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAD4SURBVEhL7ZZJCsJAEEX7/iKIiCjiQhTxFIKIRJyHuBIRoyC4ENy5UL8pM1AdC4e0uMqHR2iq6nVCIGkFN6sj0FgA2R6QsuJD8+QhH0WN9nKjKeRV+YFc5NRt744CaJ3uyr0B9BRKKnBo8872mcJQ7ue8lZugyUtjvfgtxZG+1uTXm/eW44bmuU+T/yLcl8jDcF8iD8N9iTwM9yXyMNz3P7npJ5fCfZrc9GcRndfkr6jOgOYaqM3lusRH8tbGf2Y/1k7ui6JyfbnACQ45QZyT3Md5HC3ajlzklCfA0t3gfPGulancxyHv4zhnH7yBjOFxjubJQz4AuAN5vh5bLRkjdQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = UqHI
// module chunks = 3